<template>
  <div class="login-container">
    <section class="login-story">
      <div class="login-brand"><span class="brand-mark"><i class="el-icon-folder-opened"></i></span><span>文件空间<small>FILE SPACE</small></span></div>
      <div class="login-story-copy"><span class="eyebrow">一处空间，无限可能</span><h1>文件在这里，<br>协作从这里开始。</h1><p>让每一份资料井然有序，<br>让每一个想法自由流动。</p><div class="login-file-stack" aria-hidden="true"><div class="stack-sheet sheet-back"></div><div class="stack-sheet sheet-front"><i class="el-icon-document"></i><span class="sheet-line"></span><span class="sheet-line short"></span></div><span class="stack-label"><i class="el-icon-check"></i> 分享，让价值被看见</span></div></div>
      <span class="login-story-footer">整理 · 分享 · 连接</span>
    </section>
    <div class="login-card">
      <span class="login-welcome">WELCOME BACK</span>
      <div class="login-title">欢迎回来</div>
      <p class="login-description">登录你的文件空间，继续今天的工作。</p>
      
      <el-tabs v-model="loginType" class="login-tabs">
        <el-tab-pane label="账号密码登录" name="account">
          <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="80px">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="loginForm.username" prefix-icon="el-icon-user" placeholder="输入你的用户名" autocomplete="username" @keyup.enter.native="handleLogin"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="loginForm.password" type="password" prefix-icon="el-icon-lock" placeholder="输入登录密码" autocomplete="current-password" show-password @keyup.enter.native="handleLogin"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleLogin" style="width: 100%" :loading="loading">
                登录空间 <i class="el-icon-right"></i>
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        
        <el-tab-pane label="访客登录" name="guest">
          <el-form :model="guestForm" :rules="guestRules" ref="guestForm" label-width="80px">
            <el-form-item label="访客码" prop="guestCode">
              <el-input 
                v-model="guestForm.guestCode" 
                prefix-icon="el-icon-key"
                placeholder="请输入访客码"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleGuestLogin" style="width: 100%" :loading="loading">
                访客登录
              </el-button>
            </el-form-item>
            <div class="guest-tip">
              <i class="el-icon-info"></i> 访客仅可访问文件共享中心
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div class="login-register">还没有账号？ <router-link to="/register">创建账号 <i class="el-icon-top-right"></i></router-link></div>
      <div class="login-privacy"><i class="el-icon-lock"></i> 你的文件，由你掌握</div>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/auth' // 导入登录接口
import { setToken } from '@/utils/auth' // 导入保存token的工具

export default {
  name: 'Login',
  data() {
    return {
      loginType: 'account', // 'account' or 'guest'
      loginForm: {
        username: '',
        password: ''
      },
      guestForm: {
        guestCode: ''
      },
      loading: false,
      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      guestRules: {
        guestCode: [{ required: true, message: '请输入访客码', trigger: 'blur' }]
      }
    };
  },
  methods: {

    async handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return
        
        this.loading = true
        try {
          const res = await login(this.loginForm)
          
          if (res.data.token) {
            setToken(res.data.token)
            // 保存用户角色
            if (res.data.roles && res.data.roles.length > 0) {
              localStorage.setItem('roles', res.data.roles.join(','))
            }
            this.$message.success('登录成功，即将跳转...')

            // await this.$store.dispatch('getUserInfo')
            
            console.log('准备跳转到首页...')
            this.$router.push('/').then(() => {
              console.log('跳转成功！')
            }).catch(err => {
              console.error('跳转失败原因:', err) // 捕获跳转失败的具体错误
            })
          } else {
            // 后端返回格式异常时的处理
            this.$message.error('登录失败：未返回token')
            console.error('登录成功但无token:', res)
          }
        } catch (error) {
          console.error('登录接口调用失败:', error)
        } finally {
          this.loading = false
        }
      })
    },

    async handleGuestLogin() {
      this.$refs.guestForm.validate(async valid => {
        if (!valid) return;
        this.loading = true;
        this.loginForm.username = 'guest';
        this.loginForm.password = this.guestForm.guestCode;
        try {
          const res = await login(this.loginForm);
          
          if (res.data.token) {
            setToken(res.data.token)
            this.$message.success('访客登录成功');
            localStorage.setItem('roles', 'guest'); // 存储访客角色
            // 访客直接进入共享中心
            this.$router.push('/file/shared').then(() => {
              console.log('跳转成功！')
            }).catch(err => {
              console.error('跳转失败原因:', err) // 捕获跳转失败的具体错误
            })
          } else {
            // 后端返回格式异常时的处理
            this.$message.error('登录失败：未返回token')
            console.error('登录成功但无token:', res)
          }
      } catch (error) {
        console.error('登录接口调用失败:', error)
      } finally {
        this.loading = false
      }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
}

.login-card {
  width: 400px;
  padding: 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.login-title {
  text-align: center;
  font-size: 20px;
  color: #303133;
  margin-bottom: 20px;
}

.login-tabs {
  margin-top: 20px;
}

.guest-tip {
  margin-top: 15px;
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
}

.guest-tip i {
  margin-right: 5px;
}
</style>
